import { render, staticRenderFns } from "./signatures.vue?vue&type=template&id=7a9a0c7e&scoped=true&lang=html"
import script from "./signatures.vue?vue&type=script&lang=js"
export * from "./signatures.vue?vue&type=script&lang=js"
import style0 from "./signatures.vue?vue&type=style&index=0&id=7a9a0c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9a0c7e",
  null
  
)

export default component.exports